import React from 'react';
import { Search, Map, GitMerge, TrendingUp } from 'lucide-react';
export function GettingStarted() {
  const steps = [{
    title: 'Map Your Capabilities',
    icon: Search,
    description: 'Identify the atoms (capabilities) your organisation has and needs. What skills, expertise, and knowledge exist? Where are the gaps?',
    question: 'What capabilities does this outcome require?'
  }, {
    title: 'Understand Your Molecules',
    icon: Map,
    description: 'Map people to their actual capabilities, not their job titles. Map services to the capabilities they require to build, run, and change safely.',
    question: 'Where is capability concentrated or fragile?'
  }, {
    title: 'Define Cell Purposes',
    icon: GitMerge,
    description: 'For each team, articulate a clear purpose. Good purposes are specific enough to guide decisions, stable enough to persist beyond any single project, and outcome-oriented.',
    question: 'Can you articulate why this team exists?'
  }, {
    title: 'Evolve Through Recomposition',
    icon: TrendingUp,
    description: 'Make small, continuous adjustments to capability and structure. Move people between cells as needs shift. Adjust boundaries as domains evolve.',
    question: 'Should we hire, train, redesign, or automate?'
  }];
  return <section id="getting-started" className="py-16 md:py-24 bg-white" data-id="element-125">
      <div className="container mx-auto px-4 max-w-6xl" data-id="element-126">
        <div className="text-center mb-16" data-id="element-127">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4" data-id="element-128">
            Getting Started with ATD
          </h2>
          <p className="text-lg text-slate-600 max-w-2xl mx-auto" data-id="element-129">
            You don't need to reorganise your entire company overnight. Start
            applying ATD principles today.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 relative" data-id="element-130">
          {/* Connecting line for desktop */}
          <div className="hidden lg:block absolute top-12 left-0 right-0 h-0.5 bg-slate-100 -z-10" data-id="element-131" />

          {steps.map((step, index) => <div key={index} className="relative bg-white p-6 rounded-xl border border-slate-100 shadow-sm hover:shadow-md transition-shadow" data-id="element-132">
              <div className="w-12 h-12 bg-white border-2 border-indigo-100 text-indigo-600 rounded-full flex items-center justify-center mb-6 text-lg font-bold shadow-sm mx-auto lg:mx-0" data-id="element-133">
                <step.icon className="h-6 w-6" data-id="element-134" />
              </div>

              <div className="text-center lg:text-left" data-id="element-135">
                <h3 className="text-xl font-bold text-slate-900 mb-3" data-id="element-136">
                  {step.title}
                </h3>
                <p className="text-slate-600 text-sm leading-relaxed mb-4" data-id="element-137">
                  {step.description}
                </p>
                <div className="bg-indigo-50 p-3 rounded-lg border border-indigo-100" data-id="element-138">
                  <p className="text-xs font-semibold text-indigo-800 uppercase tracking-wide mb-1" data-id="element-139">
                    Key Question
                  </p>
                  <p className="text-sm text-indigo-700 italic" data-id="element-140">
                    "{step.question}"
                  </p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}